import React, { useEffect, useMemo, useState } from "react";
import { Button, Input, List, Modal, Divider, Typography } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import VideoThumbnailCard, { VideoThumbnailCardSkeleton } from "../Components/VideoThumbnailCard/VideoThumbnailCard";
import NewVideo from "../Components/NewVideo/NewVideo";
import ContentFilterPopover from "./ContentFilters/ContentFilterPopover";
import { useHistory } from "react-router-dom";

const { Text } = Typography;

const MyVideos = ({ createdVideos, loading = false, filterConfig }) => {
    const history = useHistory();
    const [newVideoModalVisible, setNewVideoModalVisible] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

    useEffect(() => {
        const timeout = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 500);

        return () => clearTimeout(timeout);
    }, [searchTerm]);
    const videoList = createdVideos?.length ? createdVideos : [];
    const filteredVideos = useMemo(() => {
        const query = debouncedSearchTerm.trim().toLowerCase();
        if (!query) {
            return videoList;
        }
        return videoList.filter((video) => {
            const title = video?.title || "";
            const embedId = video?.embedId || "";
            return `${title} ${embedId}`.toLowerCase().includes(query);
        });
    }, [videoList, debouncedSearchTerm]);
    const videoSkeletonList = Array.from({ length: 6 }, (_, index) => ({ id: `video-skeleton-${index}` }));
    const getModuleId = (video) =>
        video?.parentModule ?? video?.moduleId ?? video?.parentModuleId ?? video?.module?.id ?? null;

    const handleManageQuiz = (video) => {
        const moduleId = getModuleId(video);
        const videoId = video?.id;
        if (!moduleId || !videoId) {
            return;
        }
        history.push(`/modules/${moduleId}/videos/${videoId}/questions/create/`);
    };

    return (
        <>
            <div className="my-content-panel-head">
                <div className="my-content-panel-head-title">
                    <h3>My Videos</h3>
                    <Text className="my-content-panel-subtitle" type="secondary">
                        Browse and manage your uploaded video library
                    </Text>
                </div>

                <Divider style={{ margin: "0" }} />
                <div className="my-content-toolbar">
                    <Input
                        style={{ width: "30%" }}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        prefix={<SearchOutlined />}
                        placeholder="Search videos..."
                    />
                    {/* <Tag>All</Tag>
                    <Tag>SmartSlides</Tag>
                    <Tag>YouTube</Tag>
                    <Tag>Vimeo</Tag> */}
                    <ContentFilterPopover
                        content={filterConfig?.content}
                        selectedTags={filterConfig?.selectedTags || []}
                        onClear={filterConfig?.onClear}
                    />
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => setNewVideoModalVisible(true)}>
                        New Video
                    </Button>
                </div>
            </div>
            <Modal
                title="New Video"
                visible={newVideoModalVisible}
                footer={null}
                destroyOnClose
                width={760}
                onCancel={() => setNewVideoModalVisible(false)}>
                    <div className="new-video-modal-content" style={{ padding: "16px" }}>
                        <NewVideo
                            onCancel={() => setNewVideoModalVisible(false)}
                        />
                    </div>
                </Modal>
            <List
                className="my-content-video-list"
                grid={{
                    gutter: [16, 16],
                    xs: 1,
                    sm: 2,
                    md: 4,
                    lg: 4,
                    xl: 4,
                    xxl: 4
                }}
                dataSource={loading ? videoSkeletonList : filteredVideos}
                pagination={{
                    pageSize: 12
                }}
                renderItem={(video, index) => (
                    <List.Item key={video.id || video.title || index}>
                        {loading ? (
                            <VideoThumbnailCardSkeleton />
                        ) : (
                            <VideoThumbnailCard
                                index={index}
                                video={video}
                                hoverable={false}
                                showTopOverlay={true}
                                searchTerm={debouncedSearchTerm}
                                showMenu={false}
                                onManageQuiz={getModuleId(video) && video?.id ? handleManageQuiz : null}
                            />
                        )}
                    </List.Item>
                )}
            />
        </>
    );
};

export default MyVideos;
